import { useTheme } from "@mui/material";
import { TierCardWrapper } from "@src/appV2/redesign/Tiers/Cards/TierCardWrapper";
import { TIERS_CARD_IMAGE_SIZE } from "@src/appV2/redesign/Tiers/utils/constants";
// eslint-disable-next-line no-restricted-imports
import Lock from "@src/assets/images/lock.png";

export function LimitedTierCardWrapper(props: { children: React.ReactNode }) {
  const { children } = props;
  const theme = useTheme();

  return (
    <TierCardWrapper
      image={Lock}
      imageSize={TIERS_CARD_IMAGE_SIZE}
      background={theme.palette.tiers?.limited?.background}
      transform="rotate(-20deg)"
    >
      {children}
    </TierCardWrapper>
  );
}
